<template>
  <div v-if="!isMissingWebsite" class="description metric-colon">
    <span class="label" :id="websiteLabelId" v-html="descDisplayText"></span>
    <template v-if="hasWebsiteSlot">
      <template v-for="(website, idx) in websiteInfoArray" >
        <LinkExternalUrl v-if="website.isValidWebsite" :key="`website-${idx}`" :url="website.url" :labelId="websiteLabelId"/><template v-else>{{website.url}}</template><span :key="`s-${idx}`" v-if="idx!==websiteInfoArray.length-1">;<br></span>
      </template>
    </template>
    <template v-else>{{defaultValue}}</template>
  </div>
</template>

<script>
import Component, { mixins } from 'vue-class-component'

import LinkExternalUrl from '@/components/LinkExternalUrl'
import { MetadataDescMixin, MetadataWebsiteMixin } from './metadata-mixin'

// Regex to check for common 'invalid' website urls:
//  - space or comma for multiple URLs in a list
//  - @ for email addresses
//  - N/A
const re = /[\s,@]|^N\/A$/

@Component({
  components: {
    LinkExternalUrl
  }
})
export default class MetricDescColon extends mixins(MetadataDescMixin, MetadataWebsiteMixin) {
  /* Getters */

  get websiteInfoArray () {
    if (!this.hasWebsiteValue) return []

    // in case there are spaces, newline etc after ';', replace() would get rid of them
    const ret = this.websiteValue.split(';').reduce((accum, url) => {
      const urlCleaned = url.replace(/^\s*/, '')
      if (urlCleaned) {
        accum.push({
          url: urlCleaned,
          isValidWebsite: !re.test(urlCleaned)
        })
      }
      return accum
    }, [])

    // we can add '; ' to all but the last urls, so we don't need a span for
    // '; ' in the template and the long line within v-for can made 2 lines,
    // but '; ' would be displayed as part of an url.
    /* for (let i = 0; i < ret.length - 1; i++) {
      ret[i].url += '; '
    } */

    return ret
  }

  get isMissingWebsite () { return this.hasWebsiteSlot && !this.websiteInfoArray.length }
  get websiteLabelId () {
    return this.hasWebsiteSlot ? 'metric-desc-colon-' + this._uid : undefined
  }

  // Override default template text if there is website text
  get customTemplateText () { return this.websiteDispText }
}
</script>

<style lang="scss">
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/sqs/2024/tab-mods/MetricDescColon.vue